export default class CreateAttachmentItemParameters
{
	constructor(entityTypeId,entityId) 
	{
		this.AttachmentId="";
		this.EntityTypeId=entityTypeId;
		this.EntityId=entityId;
		this.Name="";
		this.Description="";
		this.SelectedFile=null;
	}
	
}